import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'
import _imports_1 from '@/assets/imgcaptions/icon_jcguize.svg'
import _imports_2 from '@/assets/imgcaptions/icon_jcguizesel.svg'
import _imports_3 from '@/assets/imgcaptions/icon_jczimu.svg'
import _imports_4 from '@/assets/imgcaptions/icon_jczimusel.svg'
import _imports_5 from '@/assets/imgcaptions/icon_shijianma.svg'
import _imports_6 from '@/assets/imgcaptions/icon_shijianmasel.svg'


const _hoisted_1 = { class: "contrastBox" }
const _hoisted_2 = { class: "contrastBoxTitle" }
const _hoisted_3 = { class: "topRout" }
const _hoisted_4 = { class: "titleBox" }
const _hoisted_5 = { class: "titleBoxLeft" }
const _hoisted_6 = { class: "titleBoxLeftVersion" }
const _hoisted_7 = { class: "versionName" }
const _hoisted_8 = { class: "versionNum" }
const _hoisted_9 = { class: "iconBox" }
const _hoisted_10 = { class: "controlBoxStyle controlBoxBtn" }
const _hoisted_11 = { class: "controlBoxStyle simplifiedBox" }
const _hoisted_12 = { class: "controlBoxStyle" }
const _hoisted_13 = { class: "contrastInner" }
const _hoisted_14 = { class: "contrastInnerleft" }
const _hoisted_15 = { class: "innerleft" }
const _hoisted_16 = { class: "innerleftTitle" }
const _hoisted_17 = { class: "innerleftList" }
const _hoisted_18 = { class: "innerleftListHead" }
const _hoisted_19 = { class: "headLeft" }
const _hoisted_20 = {
  key: 0,
  class: "rowTime"
}
const _hoisted_21 = { class: "innerleftListCaption" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "headLeft" }
const _hoisted_24 = { class: "rowIndex" }
const _hoisted_25 = {
  key: 0,
  class: "rowTime"
}
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "headRight" }
const _hoisted_29 = { class: "headRightInner" }
const _hoisted_30 = { class: "textcontainer" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_33 = { class: "textcontainer" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_36 = { class: "headRightInnerRight" }
const _hoisted_37 = { class: "rowKey" }
const _hoisted_38 = { class: "contrastInnerRight" }
const _hoisted_39 = { class: "innerleft" }
const _hoisted_40 = { class: "innerleftTitle" }
const _hoisted_41 = { class: "innerleftList" }
const _hoisted_42 = { class: "innerleftListHead" }
const _hoisted_43 = { class: "headLeft" }
const _hoisted_44 = {
  key: 0,
  class: "rowTime"
}
const _hoisted_45 = { class: "innerleftListCaption" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "headLeft" }
const _hoisted_48 = { class: "rowIndex" }
const _hoisted_49 = {
  key: 0,
  class: "rowTime"
}
const _hoisted_50 = { class: "" }
const _hoisted_51 = { class: "" }
const _hoisted_52 = { class: "headRight" }
const _hoisted_53 = { class: "headRightInner" }
const _hoisted_54 = { class: "textcontainer" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_57 = { class: "textcontainer" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_60 = { class: "headRightInnerRight" }
const _hoisted_61 = { class: "rowKey" }

import routerBox from "@/components/common/routerBox.vue"
// 引入我的模块
import mainBox from "@/components/common/mainBox.vue"
import { ref, onMounted,watch} from 'vue'
// 时间处理方法
import { timeInfo, timeInfominute, timedata } from '@/components/public-method/time-method';
import control from "./control.vue"
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";
// 引入页面图标
import { applicationDetail } from "@/views/captions/icon.ts";
// 引入下拉框
import menuPage from "@/components/common/menuPage.vue";
import {
    Close,
} from "@element-plus/icons-vue";
import { ElScrollbar } from 'element-plus'
import { useRouter,useRoute  } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'captionContrast',
  setup(__props) {

// 引入路由模块
const route=useRoute()
const showWidth={
    width:'16rem',
    noW:'7rem'
}
const router = useRouter();
const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>()
const scrollbarRefTwo = ref<InstanceType<typeof ElScrollbar>>()
const menuShow=ref(false)
const videoTitle=ref('')
watch(route, (to, from) => {
    let ids =  router.currentRoute.value.query.id;
    let subtitleId =  router.currentRoute.value.query.oldId;
    selIndex.value=0
    editTextIndex.value=-1
    editTextIndexType.value = ""
    scrollbarRef.value!.setScrollTop(0)
    scrollbarRefTwo.value!.setScrollTop(0)
    if(ids!=undefined){
        getVersList(subtitleId,ids) 
    }
    

})
onMounted(() => {
    let ids =  router.currentRoute.value.query.id;
    let subtitleId =  router.currentRoute.value.query.oldId;
    console.log(subtitleId)
    getVersList(subtitleId,ids)
})
// 
const toback=()=>{
    let oldId= router.currentRoute.value.query.oldId;
    router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: oldId } })
}
const captionOne = ref()//第一个版本字幕
const versionOne= ref("")
const textIdOne=ref('')
const captiontwo = ref()//第二个版本字幕
const versiontwo= ref("")
const textIdTwo=ref('')
const subtitleId=ref('')
const styleinspectRule = {
    color: 'rgba(255, 54, 61, .6)',
}
// 获取多版本
const getVersList = (subtitleid,ids) => {
    newCaptionApi.getEditCaption(subtitleid,ids).then(res => {
        console.log(res)
        captionOne.value = res.data[0].subtitles
        versionOne.value=res.data[0].version
        textIdOne.value=res.data[0].textId
        captiontwo.value = res.data[1].subtitles
        versiontwo.value=res.data[1].version
        textIdTwo.value=res.data[1].textId
        videoTitle.value=""
        subtitleId.value=res.data[1].subtitleId
    })
}
// 滚动
const scrollFu=(e)=>{
    // console.log(e)
    scrollbarRef.value!.setScrollTop(e.scrollTop)
    scrollbarRefTwo.value!.setScrollTop(e.scrollTop)
}
// 
const selIndex=ref(0)
const selStyle={
    'background':'rgba(30,104,201,0.3)'
}
const selRow=(index:number)=>{
    selIndex.value=index
}
// 编辑字幕
const editTextIndex=ref(-1)
const editTextIndexType=ref('')
const editText = (index: number, type: string, data: any,thisData:string) => {
    closedAll()
    editTextIndex.value=index
    editTextIndexType.value = type+thisData
    if(thisData=='one'){
        console.log('编辑字幕')
    }

}
const updataText = (type: string, index: number, text: string) => {
    console.log(type)
   
    
}
// 编辑封装
const editFunction = (textId:string , data: any, id: string,line:number,type:string) => {
   
    newCaptionApi.putEditCaption(textId, data, id,line+ 1,type ).then(res => {
        if (res.code == 200) {
            console.log('编辑成功')
        }
    })
    

}
// 原文编辑
const originalEdit=(type:string,id:string,index:number)=>{
    if(type=='one'){
        const data = {
            text: captionOne.value[index].original.text
        }
        editFunction(textIdOne.value , data, id,index,'modifyOriginalText')
    }else{
        const data = {
            text: captiontwo.value[index].original.text
        }
        editFunction(textIdTwo.value , data, id,index,'modifyOriginalText')
    }
}
// 译文编辑
const translationEdit=(type:string,id:string,index:number)=>{
    if(type=='one'){
        const data = {
            text: captionOne.value[index].translation.text
        }
        editFunction(textIdOne.value , data, id,index,'modifyTranslationText')
    }else{
        const data = {
            text: captiontwo.value[index].translation.text
        }
        editFunction(textIdTwo.value , data, id,index,'modifyTranslationText')
    }
}
// 默认规则参数
const checkRule = ref({
    maximumDuration: '10',
    minimumDuration: '1',
    originalMaximumWordCount: '18',
    translationOriginalMaximumWordCount: '75'
})
const closedAll=()=>{
    ruleShow.value = false
    editTextIndex.value=-1
    editTextIndexType.value = ""
}
// 检查规则弹窗显示
const ruleShow = ref(false)
const controlFun = () => {
    closedAll()
    ruleShow.value = true
}
// 修改规则
const changeRuleFun = (data: any) => {
    console.log(data)
    ruleShow.value = false
    checkRule.value = JSON.parse(data)
    newCaptionApi.putInitOneRule(subtitleId.value, checkRule.value).then(res => {
        console.log(res.code)
    })
}
// 检查字幕弹窗显示
const textinspectShow = ref(false)
const textinspectFun = () => {
    textinspectShow.value = !textinspectShow.value

}
// 角色头像展示
const roleImgShow = ref(false)

const roleImgFun = () => {
    roleImgShow.value = true
}
// 时间码展示
const timeBoxShow = ref(true)
const timeBoxFun = () => {
    timeBoxShow.value = false
}
// 关闭所有弹窗
const closeAll = () => {
    ruleShow.value = false
    // selIndex.value=-1
}


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "logoImg",
          onMousemove: _cache[0] || (_cache[0] = ($event: any) => (menuShow.value=true))
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(applicationDetail).caption.name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(applicationDetail).caption.version), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_tooltip, {
                content: "设置规则",
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  (!ruleShow.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_1,
                        alt: "",
                        onClick: controlFun
                      }))
                    : _createCommentVNode("", true),
                  (ruleShow.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_2,
                        alt: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (ruleShow.value = false))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (ruleShow.value)
                ? (_openBlock(), _createBlock(control, {
                    key: 0,
                    class: "controlStyle",
                    initRule: checkRule.value,
                    onChangeRule: changeRuleFun,
                    onCloseThis: closeAll
                  }, null, 8, ["initRule"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_tooltip, {
                content: "规则检查",
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  (!textinspectShow.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_3,
                        alt: "",
                        onClick: textinspectFun
                      }))
                    : _createCommentVNode("", true),
                  (textinspectShow.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_4,
                        alt: "",
                        onClick: textinspectFun
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_tooltip, {
                content: "时间码",
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  (!timeBoxShow.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_5,
                        alt: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (timeBoxShow.value = true))
                      }))
                    : _createCommentVNode("", true),
                  (timeBoxShow.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_6,
                        alt: "",
                        onClick: timeBoxFun
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "toback",
          onClick: toback
        }, " 退出 ")
      ]),
      _createVNode(mainBox, { class: "topMain" }),
      _withDirectives(_createVNode(menuPage, {
        class: "menuPageStyle",
        onClosemenu: _cache[3] || (_cache[3] = ($event: any) => (menuShow.value=false)),
        onOpenmenu: _cache[4] || (_cache[4] = ($event: any) => (menuShow.value=true)),
        nameInfo: _unref(applicationDetail).caption
      }, null, 8, ["nameInfo"]), [
        [_vShow, menuShow.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[7] || (_cache[7] = _createElementVNode("div", null, null, -1)),
            _createElementVNode("div", null, _toDisplayString(versionOne.value), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "rowIndex" }, "序号", -1)),
                (timeBoxShow.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "时间码"))
                  : _createCommentVNode("", true)
              ]),
              _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"headRight\" data-v-5b1e947f><div class=\"headRightInner\" data-v-5b1e947f>字幕</div><div class=\"headRightInnerRight\" data-v-5b1e947f><div class=\"rowKey\" data-v-5b1e947f>字符</div><div class=\"timeLang\" data-v-5b1e947f>时长</div></div></div>", 1))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_unref(ElScrollbar), {
                height: "100%",
                onScroll: _cache[5] || (_cache[5] = ($event: any) => (scrollFu($event))),
                ref_key: "scrollbarRef",
                ref: scrollbarRef
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(captionOne.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "captionOne",
                      onClick: ($event: any) => (selRow(index)),
                      key: index,
                      style: _normalizeStyle(selIndex.value==index?selStyle:'')
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(index + 1), 1),
                        (timeBoxShow.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(timeInfo)(item.beginTime)), 1),
                              _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(timeInfo)(item.endTime)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            (editTextIndex.value != index || editTextIndexType.value != 'cnone' || editTextIndexType.value == '')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "textBox",
                                  onClick: ($event: any) => (editText(index, 'cn', item,'one')),
                                  style: _normalizeStyle(item.original.textColor != undefined ? { color: item.original.textColor } : { color: '' })
                                }, _toDisplayString(item.original.text), 13, _hoisted_31))
                              : _createCommentVNode("", true),
                            (editTextIndex.value == index && editTextIndexType.value == 'cnone')
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((item.original.text) = $event),
                                  onInput: ($event: any) => (updataText('cn', index, item.original.text)),
                                  onBlur: ($event: any) => (originalEdit('one',item.id,index))
                                }, null, 40, _hoisted_32)), [
                                  [_vModelText, item.original.text]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            (
                                                (editTextIndex.value != index || editTextIndexType.value != 'enone' || editTextIndexType.value == '')&&item.translation!=undefined&&item.translation.text!=undefined)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "textBox",
                                  onClick: ($event: any) => (editText(index, 'en', item,'one')),
                                  style: _normalizeStyle(item.translation.textColor != undefined ? { color: item.translation.textColor } : { color: '' })
                                }, _toDisplayString(item.translation.text), 13, _hoisted_34))
                              : _createCommentVNode("", true),
                            (editTextIndex.value == index && editTextIndexType.value == 'enone')
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((item.translation.text) = $event),
                                  onInput: ($event: any) => (updataText('en', index, item.translation.text)),
                                  onBlur: ($event: any) => (translationEdit('one',item.id,index))
                                }, null, 40, _hoisted_35)), [
                                  [_vModelText, item.translation.text]
                                ])
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", {
                              style: _normalizeStyle((textinspectShow.value && ((item.original.text.length) > checkRule.value.originalMaximumWordCount)) ? styleinspectRule : '')
                            }, _toDisplayString(item.original.text.length), 5),
                            (item.translation!=undefined&&item.translation.text!=undefined)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  style: _normalizeStyle((textinspectShow.value && ((item.translation.text.length) > checkRule.value.translationOriginalMaximumWordCount)) ? styleinspectRule : '')
                                }, _toDisplayString(item.translation.text.length), 5))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "timeLang",
                            style: _normalizeStyle((textinspectShow.value && ((((item.endTime - item.beginTime) / 1000)) > checkRule.value.maximumDuration || (((item.endTime - item.beginTime) / 1000)) < checkRule.value.minimumDuration)) ? styleinspectRule : '')
                          }, _toDisplayString(((item.endTime - item.beginTime) / 1000).toFixed(2)) + " 秒", 5)
                        ])
                      ])
                    ], 12, _hoisted_22))
                  }), 128))
                ]),
                _: 1
              }, 512)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", null, _toDisplayString(versiontwo.value), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "rowIndex" }, "序号", -1)),
                (timeBoxShow.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, "时间码"))
                  : _createCommentVNode("", true)
              ]),
              _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"headRight\" data-v-5b1e947f><div class=\"headRightInner\" data-v-5b1e947f>字幕</div><div class=\"headRightInnerRight\" data-v-5b1e947f><div class=\"rowKey\" data-v-5b1e947f>字符</div><div class=\"timeLang\" data-v-5b1e947f>时长</div></div></div>", 1))
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_unref(ElScrollbar), {
                height: "100%",
                onScroll: _cache[6] || (_cache[6] = ($event: any) => (scrollFu($event))),
                ref_key: "scrollbarRefTwo",
                ref: scrollbarRefTwo
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(captiontwo.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "captionOne",
                      onClick: ($event: any) => (selRow(index)),
                      key: index,
                      style: _normalizeStyle(selIndex.value==index?selStyle:'')
                    }, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, _toDisplayString(index + 1), 1),
                        (timeBoxShow.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(timeInfo)(item.beginTime)), 1),
                              _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(timeInfo)(item.endTime)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            (editTextIndex.value != index || editTextIndexType.value != 'cntwo' || editTextIndexType.value == '')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "textBox",
                                  onClick: ($event: any) => (editText(index, 'cn', item,'two')),
                                  style: _normalizeStyle(item.original.textColor != undefined ? { color: item.original.textColor } : { color: '' })
                                }, _toDisplayString(item.original.text), 13, _hoisted_55))
                              : _createCommentVNode("", true),
                            (editTextIndex.value == index && editTextIndexType.value == 'cntwo')
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((item.original.text) = $event),
                                  onInput: ($event: any) => (updataText('cn', index, item.original.text)),
                                  onBlur: ($event: any) => (originalEdit('two',item.id,index))
                                }, null, 40, _hoisted_56)), [
                                  [_vModelText, item.original.text]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            ((editTextIndex.value != index || editTextIndexType.value != 'entwo' || editTextIndexType.value == '')&&item.translation!=undefined&&item.translation.text!=undefined)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "textBox",
                                  onClick: ($event: any) => (editText(index, 'en', item,'two')),
                                  style: _normalizeStyle(item.translation.textColor != undefined ? { color: item.translation.textColor } : { color: '' })
                                }, _toDisplayString(item.translation.text), 13, _hoisted_58))
                              : _createCommentVNode("", true),
                            (editTextIndex.value == index && editTextIndexType.value == 'entwo')
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((item.translation.text) = $event),
                                  onInput: ($event: any) => (updataText('en', index, item.translation.text)),
                                  onBlur: ($event: any) => (translationEdit('two',item.id,index))
                                }, null, 40, _hoisted_59)), [
                                  [_vModelText, item.translation.text]
                                ])
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", {
                              style: _normalizeStyle((textinspectShow.value && ((item.original.text.length) > checkRule.value.originalMaximumWordCount)) ? styleinspectRule : '')
                            }, _toDisplayString(item.original.text.length), 5),
                            (item.translation!=undefined&&item.translation.text!=undefined)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  style: _normalizeStyle((textinspectShow.value && ((item.translation.text.length) > checkRule.value.translationOriginalMaximumWordCount)) ? styleinspectRule : '')
                                }, _toDisplayString(item.translation.text.length), 5))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "timeLang",
                            style: _normalizeStyle((textinspectShow.value && ((((item.endTime - item.beginTime) / 1000)) > checkRule.value.maximumDuration || (((item.endTime - item.beginTime) / 1000)) < checkRule.value.minimumDuration)) ? styleinspectRule : '')
                          }, _toDisplayString(((item.endTime - item.beginTime) / 1000).toFixed(2)) + " 秒", 5)
                        ])
                      ])
                    ], 12, _hoisted_46))
                  }), 128))
                ]),
                _: 1
              }, 512)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})